import React from 'react';

const TraceOffBtn = (props) => (
    <div 
    	className={`trace-off-btn trace-btn ${props.selected && 'on'}`} 
    	onClick={props.onClick}
    ></div>
);

export default TraceOffBtn;


// WEBPACK FOOTER //
// ./src/components/sections/shared/TraceOffBtn.js